<div id="bottomDialog" class="bottom-dialog-container text">
  <ng-container *ngIf="isMobileView">
    <current-slip-core></current-slip-core>
  </ng-container>
</div>
